import { render } from "./Tracking.vue?vue&type=template&id=4c6bb2fa&scoped=true"
import script from "./Tracking.vue?vue&type=script&lang=js"
export * from "./Tracking.vue?vue&type=script&lang=js"

import "./Tracking.vue?vue&type=style&index=0&id=4c6bb2fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c6bb2fa"]])

export default __exports__